<template v-if="this.user.loggedIn">
  <div class="container">
    <div v-if="message.success !== undefined">
      <div class="alert alert-success fixed-top text-center" role="alert">
        {{ message.success }}
      </div>
    </div>
    <div v-if="message.error !== undefined">
      <div class="alert alert-danger fixed-top text-center" role="alert">
        {{ message.error }}
      </div>
    </div>
    <form
      @submit.prevent="loadApplicationByCode()"
      class="form-inline w-100 mb-3"
    >
      <b-form-input
        class="mr-sm-2"
        placeholder="Freigabecode eingeben..."
        v-model="releaseCode"
      ></b-form-input>
      <b-button variant="primary" type="submit" :disabled="!releaseCode"
        ><span v-if="loadingApplication"
          ><b-spinner small label="Lade Bewerbung..."></b-spinner
        ></span>
        Bewerbung&nbsp;laden</b-button
      >
    </form>
    <div class="card">
      <div
        v-if="!dataArray"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <table class="table table-hover m-0" v-else>
        <thead>
          <tr>
            <th>Name</th>
            <th>Stelle</th>
            <th>Abteilung</th>
            <th>Eingegangen</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in dataArray" :key="index">
          <tr @click="createNew(item.id)" v-if="item.archive === false">
            <td>
              <span v-if="item?.firstname">{{
                item?.firstname + " " + item?.name
              }}</span>
              <span v-else>{{ item?.email }}</span>
            </td>
            <td>{{ item?.jobOfferName }}</td>
            <td>
              {{ item?.department }}
              <template v-if="item?.trainee"
                ><br /><b-badge>Ausbildung</b-badge></template
              >
            </td>
            <td>{{ convert(item.incoming.toDate()) }}</td>
            <td v-if="user.data.claims.betrachter">
              <b-badge
                v-if="
                  item?.needReplyFrom &&
                  item.needReplyFrom.includes(user.data.email)
                "
                variant="danger"
                >Antwort ausstehend</b-badge
              >
              <b-badge v-else variant="success">Bereits geantwortet</b-badge>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      size="xl"
      tabindex="-1"
      role="dialog"
      v-model="formularModal"
      :title="jobOfferName"
      aria-hidden="true"
      hide-footer
    >
      <div
        v-if="personData == '' || personData == undefined"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div
        v-if="personData !== '' && personData !== undefined"
        class=""
        style="width: 100%"
      >
        <div id="printMe">
          <h4 class="printOnly">{{ jobOfferName }}</h4>
          <b-form-group label="Stelle auswählen" v-if="!jobOfferName">
            <b-form-select
              v-if="jobOptions.length > 0"
              v-model="selectedJobId"
              :options="jobOptions"
              text-field="text"
              value-field="value"
              @change="applyJobData"
              class="mb-3"
            />
          </b-form-group>
          <div>
            <p class="m-0"><b>Name</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.firstname + " " + personData?.name }}</p>
            </div>
            <div v-else>
              <b-form-input
                v-model="personData.firstname"
                placeholder="Vorname"
                class="mb-1"
              />
              <b-form-input v-model="personData.name" placeholder="Nachname" />
            </div>
            <p v-if="personData?.birthday" class="m-0"><b>Geburtstag</b></p>
            <p>{{ personData?.birthday }}</p>
            <p v-if="personData?.street" class="m-0"><b>Adresse</b></p>
            <p v-if="personData?.street" class="m-0">
              {{ personData?.street }}
            </p>
            <p v-if="personData?.town" class="m-0">
              {{ personData?.zip + " " + personData?.town }}
            </p>
            <p>{{ personData?.country }}</p>
            <p class="m-0"><b>Telefon</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.phonenumber }}</p>
            </div>
            <div v-else>
              <b-form-input
                v-model="personData.phonenumber"
                placeholder="Telefonnummer eingeben"
              />
            </div>
            <p v-if="personData?.email" class="mt-2"><b>E-Mail</b></p>
            <p>{{ personData?.email }}</p>
          </div>
          <div v-if="personData?.image">
            <ImageBlob :data="{ image: personData?.image }" />
          </div>
          <hr v-if="personData?.coverLetter" />
          <div v-if="personData?.privacyPolicy">
            <p v-if="personData?.coverLetter"><b>Anschreiben</b></p>
            <div v-html="personData?.coverLetter"></div>
          </div>
          <b-button
            variant="success"
            class="mt-2"
            @click="saveMissingFields()"
            v-if="changed"
            >Speichern</b-button
          >
          <div>
            <hr />
            <div
              v-if="
                personData?.curriculumVitae || personData?.otherDocuments.length
              "
            >
              <p>
                Mir ist bewusst, dass ich die Dateien nach der Durchsicht
                endgültig löschen muss, um den Datenschutzbestimmungen zu
                entsprechen. Mit dem Anklicken des Kontrollkästchens bestätige
                ich dies.
              </p>
              <input type="checkbox" id="show-files" v-model="showFiles" />
              <label for="show-files">&nbsp; Dateien anzeigen</label>
            </div>
            <p class="m-0"><b>Anlagen</b></p>
            <p v-if="personData?.curriculumVitae" class="m-0">
              <small>Lebenslauf</small>
            </p>
            <div
              v-for="(item, index) in personData?.otherDocuments"
              :key="index"
            >
              <p class="m-0">
                <small>{{ item.name }} </small>
              </p>
            </div>
          </div>
        </div>
        <hr v-if="personData?.curriculumVitae" />
        <p
          v-if="
            personData?.curriculumVitae || personData?.otherDocuments.length
          "
        >
          <b>Dateien</b>
        </p>
        <div v-if="showFiles === true">
          <ButtonBlob
            :data="{ data: personData?.curriculumVitae }"
            v-if="personData?.curriculumVitae"
          />
          <DropDownButtonBlob
            :data="personData?.otherDocuments"
            v-if="personData?.otherDocuments.length > 0"
          />
        </div>
        <hr />
        <p><b>Notizen</b></p>
        <b-form-textarea
          v-model="leaderNotes"
          rows="6"
          placeholder="Notizen zur Bewerbung..."
        ></b-form-textarea>
        <b-button variant="success" class="mt-2" @click="saveLeadersNotes()"
          >Speichern</b-button
        >
        <hr />
        <div v-if="user.data.claims.betrachter === true || user.data.claims.betrachter === 'true'">
          <p><b>Personalabteilung antworten</b></p>
          <b-form-group
            label="Antwort auswählen und ggf. um eigene Nachricht ergänzen:"
          >
            <b-form-select
              v-model="selected"
              :options="answerOptionsForAl"
              class="mb-3"
            />
            <b-form-textarea v-model="answerText" rows="6"></b-form-textarea>
            <b-button
              variant="primary"
              class="mt-2"
              @click="sendAnswerToHR()"
              :disabled="!selected"
            >
              <span v-if="loading">
                <b-spinner small type="grow" label="Loading..."></b-spinner>
                Senden...
              </span>
              <span v-else> Absenden </span>
            </b-button>
          </b-form-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { functions, firestore } from "../plugins/firebase";
// eslint-disable-next-line
import {
  query,
  collection,
  getDocs,
  doc,
  updateDoc,
  where,
  orderBy,
  deleteField,
  arrayRemove,
  arrayUnion,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import moment from "moment";
import ImageBlob from "./ImageBlob";
import ButtonBlob from "./ButtonBlob";
import DropDownButtonBlob from "./DropDownButtonBlob";

export default {
  name: "ApplicationsWatcherPage",
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  components: {
    ImageBlob,
    ButtonBlob,
    DropDownButtonBlob,
  },
  watch: {
    personData: {
      handler(newD) {
        // console.log('personData changed', newD.firstname, this.personDataOriginal.firstname);
        if (
          newD.firstname !== this.personDataOriginal.firstname ||
          newD.name !== this.personDataOriginal.name ||
          newD.phonenumber !== this.personDataOriginal.phonenumber
        )
          this.changed = true;
      },
      deep: true,
    },
  },
  data() {
    return {
      changed: false,
      dataArray: undefined,
      message: {
        success: undefined,
        error: undefined,
      },
      formularModal: false,
      personData: undefined,
      personDataOriginal: undefined,
      jobOfferName: undefined,
      personId: undefined,
      selected: undefined,
      curriculumVitaeURL: undefined,
      textTamplates: [{ text: "Wähle einen Antworttext...", value: null }],
      selectedJob: null,
      selectedJobId: null,
      jobOptions: [],
      answerOptionsForAl: ["Einladung", "Absage", "persönliche Rücksprache"],
      answerText: "",
      loading: false,
      showFiles: false,
      releaseCode: "",
      loadingApplication: false,
      leaderNotes: "",
    };
  },
  methods: {
    applyJobData() {
      this.changed = true;
      const selected = this.jobOptions.find(
        (j) => j.value === this.selectedJobId
      );
      if (selected && selected.full) {
        const job = selected.full;
        this.personData.jobOfferName = job.jobOfferName || "";
        this.personData.department = job.department || "";
        this.personData.workingStart = job.workingStart || "";
        this.personData.workingTime = job.workingTime || "";
        this.personData.type = job.type || "";
        this.personData.limited = job.limited || "";
        this.changed = true;
      }
      this.selectedJob = selected;
    },
    async saveMissingFields() {
      if (this.selectedJob) {
        this.personData.jobOfferName = this.selectedJob.value.job;
        this.personData.department = this.selectedJob.value.department;
      }

      await updateDoc(
        doc(firestore, "application", this.personId),
        this.personData
      )
        .then(() => {
          this.message.success = "Daten wurden ergänzt.";
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Fehler beim Speichern: " + error;
          setTimeout(this.resetMessage, 3000);
        });
      this.changed = false;
    },
    async saveLeadersNotes() {
      console.log(
      "Saving leader notes for",
      this.personId,
      this.leaderNotes
      );
      
      const leaderEmail = this.$store.state.user.data.email;
      const existingNotes = this.personData.leaderNotes || [];
      const existingIndex = existingNotes.findIndex(
      (item) => item.leader === leaderEmail
      );
      
      let updatedNotes;
      if (existingIndex !== -1) {
      // Update existing entry
      updatedNotes = [...existingNotes];
      updatedNotes[existingIndex] = {
        note: this.leaderNotes,
        leader: leaderEmail,
      };
      } else {
      // Add new entry
      updatedNotes = [
        ...existingNotes,
        {
        note: this.leaderNotes,
        leader: leaderEmail,
        },
      ];
      }
      
      await updateDoc(doc(firestore, "application", this.personId), {
      leaderNotes: updatedNotes,
      })
      .then(() => {
        this.message.success = "Notizen wurden gespeichert.";
        setTimeout(this.resetMessage, 3000);
      })
      .catch((error) => {
        this.message.error = "Fehler beim Speichern: " + error;
        setTimeout(this.resetMessage, 3000);
      });
    },
    async loadData(code, mail, uid) {
      this.loadResponses();
      let q;
      if (code && mail) {
        q = query(
          collection(firestore, "application"),
          orderBy("incoming"),
          where("releaseCodes", "array-contains", code)
        );
      } else {
        q = query(
          collection(firestore, "application"),
          orderBy("incoming"),
          where("uidArr", "array-contains", uid)
        );
      }
      const querySnapshot = await getDocs(q);
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ ...doc.data(), id: doc.id });
      });

      this.dataArray = tempData;

      if (code) {
        for await (let item of this.dataArray) {
          const releaseCodesArr = item.releaseCodes;
          if (!Array.isArray(releaseCodesArr) || !releaseCodesArr.includes(code)) {
            continue;
          }
          const docRef = doc(firestore, "application", item.id);
          if (releaseCodesArr.length === 1) {
            await updateDoc(docRef, {
              releaseCodes: deleteField(),
              uidArr: arrayUnion(this.$store.state.user.data.uid),
            });
          } else {
            await updateDoc(docRef, {
              releaseCodes: releaseCodesArr.filter((item) => item !== code),
              uidArr: arrayUnion(this.$store.state.user.data.uid),
            });
          }
        }
      }
      this.releaseCode = "";
    },
    async loadJobOffers() {
      const q = query(collection(firestore, "jobOffers"));
      const querySnapshot = await getDocs(q);
      this.jobOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.jobOfferName,
          value: {
            job: data.jobOfferName,
            department: data.department,
          },
        };
      });
    },
    async loadResponses() {
      const q = query(collection(firestore, "responseSelection"));
      const querySnapshot = await getDocs(q);
      const templateOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.title,
          value: data.text,
        };
      });
      this.textTamplates = [
        { text: "Wähle einen Antworttext...", value: null },
        ...templateOptions,
      ];
    },
    createNew(id) {
      this.personData = this.dataArray.find((item) => item.id === id);
      this.leaderNotes = this.personData.leaderNotes
        ? this.personData.leaderNotes.find(
            (item) => item.leader === this.$store.state.user.data.email
          )
          ? this.personData.leaderNotes.find(
              (item) => item.leader === this.$store.state.user.data.email
            ).note
          : ""
        : "";
      this.personDataOriginal = JSON.parse(JSON.stringify(this.personData));
      this.personId = id;
      this.formularModal = !this.formularModal;
      this.jobOfferName = this.personData?.jobOfferName;
      this.curriculumVitaeURL = undefined;
    },
    resetMessage() {
      this.message.success = undefined;
      this.message.error = undefined;
    },
    parseGermanDate(date) {
      return date.toDate();
    },
    // Hilfsfunktion um Timestamp-Objekte zu konvertieren
    convertTimestamp(timestamp) {
      if (timestamp && timestamp.seconds) {
        return new Date(timestamp.seconds * 1000);
      }
      return new Date(timestamp);
    },
    mergeEmailsAndReplies(applicationData, options = {}) {
      const { sortOrder = "asc", includeHtmlContent = true } = options;
      const mergedItems = [];
      const emails = applicationData.emails || [];
      const replies = applicationData.replyed || [];

      // 1) Original-Emails
      emails.forEach((email, idx) => {
        const dt = this.convertTimestamp(
          email.sentDateTime || email.createdDateTime
        );
        mergedItems.push({
          type: "email",
          id: idx,
          date: dt,
          dateString: dt.toLocaleDateString("de-DE"),
          subject: email.subject,
          from: email.from?.emailAddress || email.sender?.emailAddress,
          to: email.toRecipients,
          body: includeHtmlContent ? email.body?.content : email.bodyPreview,
          read: email.read,
        });
      });

      // 2) Replies (geplant oder sofort)
      // mergeEmailsAndReplies(applicationData, options = {})
      replies.forEach((reply, idx) => {
        let dt = null;

        if (
          typeof reply.sendAt === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.sendAt)
        ) {
          dt = new Date(reply.sendAt.split(".").reverse().join("-"));
        } else if (reply.sendAt instanceof Date) {
          dt = reply.sendAt;
        } else if (reply.sendAt?.toDate) {
          dt = reply.sendAt.toDate();
        }

        // 🔧 HIER NEU: Fallback auf "date" (dein altes Textdatum)
        if (
          !dt &&
          typeof reply.date === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.date)
        ) {
          dt = new Date(reply.date.split(".").reverse().join("-"));
        }

        if (!dt || isNaN(dt.getTime())) {
          dt = new Date(); // letzter Fallback
        }

        // Für die Anzeige
        const ds = dt.toLocaleDateString("de-DE");

        mergedItems.push({
          type: "reply",
          id: idx,
          date: dt,
          dateString: ds,
          subject: `Re: ${applicationData.jobOfferName || "Bewerbung"}`,
          message: reply.message,
        });
      });

      // 3) Sortierung
      mergedItems.sort((a, b) => {
        return sortOrder === "desc" ? b.date - a.date : a.date - b.date;
      });

      return mergedItems;
    },
    async sendAnswerToHR() {
      if (!this.selected) {
        this.message.error = "Bitte wähle eine Antwort aus.";
        setTimeout(this.resetMessage, 3000);
        return;
      }
      this.loading = true;
      const sendMail = httpsCallable(functions, "sendMailToHR");
      await sendMail({
        subject:
          this.personData.firstname.trim() +
          " " +
          this.personData.name.trim() +
          ": " +
          this.selected,
        text:
          this.answerText ||
          "(Es wurde keine zusätzliche Nachricht eingegeben.)",
      })
        .then(async () => {
          try {
            await updateDoc(doc(firestore, "application", this.personData.id), {
              needReplyFrom: arrayRemove(this.$store.state.user.data.email),
              repliesFromAl: arrayUnion({
                mail: this.$store.state.user.data.email,
                answer: this.selected,
                message:
                  this.answerText ||
                  "(Es wurde keine zusätzliche Nachricht eingegeben.)",
              }),
            });
          } catch (error) {
            console.error("Fehler beim Aktualisieren der Bewerbung: ", error);
          }
          this.message.success = "Antwort wurde versendet.";
          setTimeout(this.resetMessage, 3000);
          this.answerText = "";
          this.selected = null;
          this.loadData(
            undefined,
            this.$store.state.user.data.email,
            this.$store.state.user.data.uid
          );
        })
        .catch((error) => {
          this.message.error = "Fehler beim Versenden: " + error.message;
          setTimeout(this.resetMessage, 3000);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateReport() {
      this.$htmlToPaper("printMe");
    },
    answered(id) {
      let data = this.personData;
      data.reply = true;
      updateDoc(doc(firestore, "application", id), data);
    },
    replyed(id, data) {
      const now = new Date();
      const sendAt =
        this.daysDelay > 0
          ? moment().add(this.daysDelay, "days").toDate()
          : now;

      const replyEntry = {
        createdAt: now,
        sendAt: sendAt,
        message: data,
      };

      let allData = this.personData;
      if (Array.isArray(allData?.replyed)) {
        allData.replyed.push(replyEntry);
      } else {
        allData.replyed = [replyEntry];
      }

      updateDoc(doc(firestore, "application", id), allData);
    },
    convert(data) {
      var date = new Date(data);
      return moment(date).format("DD.MM.YYYY");
    },
    async loadApplicationByCode() {
      try {
        this.loadingApplicationByCode = true;
        const q = query(
          collection(firestore, "application"),
          orderBy("incoming"),
          where("archive", "==", false),
          where("releaseCodes", "array-contains", this.releaseCode)
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          this.message.error = "Kein Eintrag für den Freigabecode gefunden.";
          setTimeout(this.resetMessage, 3000);
          return;
        }
        const result = [];
        querySnapshot.forEach((doc) => {
          result.push({ ...doc.data(), id: doc.id });
        });
        this.dataArray = [...this.dataArray, ...result];
        for await (let item of this.dataArray) {
          const releaseCodesArr = item.releaseCodes;
          if (!Array.isArray(releaseCodesArr) || !releaseCodesArr.includes(this.releaseCode)) {
            continue;
          }
          const docRef = doc(firestore, "application", item.id);
          if (releaseCodesArr.length === 1) {
            await updateDoc(docRef, {
              releaseCodes: deleteField(),
              uidArr: arrayUnion(this.$store.state.user.data.uid),
            });
          } else {
            await updateDoc(docRef, {
              releaseCodes: releaseCodesArr.filter(
                (item) => item !== this.releaseCode
              ),
              uidArr: arrayUnion(this.$store.state.user.data.uid),
            });
          }
        }
        this.releaseCode = "";
      } catch (error) {
        this.message.error = "Fehler beim Laden der Bewerbung: " + error;
        setTimeout(this.resetMessage, 3000);
      } finally {
        this.loadingApplicationByCode = false;
      }
    },
  },
  mounted() {
    let code = this.$route.params.code;
    let mail = this.$store.state.user.data.email;
    let uid = this.$store.state.user.data.uid;
    code ? this.loadData(code, mail, uid) : this.loadData(undefined, mail, uid);
    this.loadJobOffers();
  },
};
</script>

<style scoped>
tr {
  cursor: pointer;
}
#personImage {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 5px;
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  margin: 16px;
  width: 240px;
}
.printOnly {
  display: none;
}
.alert {
  z-index: 999999999;
}
</style>
<style>
#mail-editor-reference-message-container {
  display: none !important;
}
</style>
